import { EASE, MOTION } from '@constants/motion';
import { prefersReducedMotion } from './motion';

/** A quick scale up and back ("something changed here"); nothing under reduced motion. */
export function bump(el: Element | null | undefined, scale: number, ms: number = MOTION.bumpMs) {
  if (!el || prefersReducedMotion()) return;
  el.animate([{ transform: 'scale(1)' }, { transform: `scale(${scale})` }, { transform: 'scale(1)' }], { duration: ms, easing: MOTION.easeOut });
}

/** A short side-to-side swing ("look here": a bell with a new alert); nothing under reduced motion. */
export function wiggle(el: Element | null | undefined, ms: number = MOTION.wiggleMs) {
  if (!el || prefersReducedMotion()) return;
  el.animate([0, -14, 12, -8, 5, 0].map((deg) => ({ transform: `rotate(${deg}deg)` })), { duration: ms, easing: MOTION.easeOut });
}

/** Side to side, settling (a form that refused a submit, like the login card); nothing under reduced motion. */
export function shake(el: Element | null | undefined, ms: number = MOTION.shakeMs) {
  if (!el || prefersReducedMotion()) return;
  el.animate([0, -6, 6, -4, 3, 0].map((px) => ({ transform: `translateX(${px}px)` })), { duration: ms, easing: EASE.shake });
}
